import gql from 'graphql-tag';

export const GET_LENDER_ACTIVITY_BY_DECLINE_REASON = gql`
  query LenderRetailActivityByDeclineReason($input: LenderRetailActivityReportInput!) {
    lenderRetailActivity {
      byDeclineReason(input: $input) {
        success
        error
        entity {
          label
          category
          count
        }
      }
    }
  }
`;
